// extracted by mini-css-extract-plugin
export default {"arrowIcon":"profile-nav-menu-option-module__arrowIcon___gZRm7"};